import * as React from "react";

import { Box, BoxProps, makeStyles, Theme } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import clsx from "clsx";

import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles<Theme>((theme) => {
  const { gray80 } = useNormalizedBrandPaletteValues(theme);
  return {
    icon: {
      color: gray80,
    },
    activeIcon: {
      color: theme.palette.common.black,
    },
    stepBackground: {
      background: theme.palette.common.white,
      display: "flex",
      left: -15,
      position: "absolute",
      top: -5,
      zIndex: 2,
    },
    stepWrapper: {
      borderLeft: `1px dotted ${gray80}`,
      paddingBottom: 32,
      paddingLeft: 38,
    },
    stepWrapperComplete: {
      borderLeftColor: theme.palette.common.black,
    },
  };
});

export const Step: React.FC<{
  containerProps?: BoxProps;
  isActive: boolean;
  isComplete: boolean;
}> = ({ children, containerProps = {}, isActive, isComplete }) => {
  const classes = useStyles();
  const classNames = clsx(
    classes.stepWrapper,
    containerProps.className,
    isComplete && classes.stepWrapperComplete
  );
  return (
    <Box position="relative" {...containerProps} className={classNames}>
      <Box className={classes.stepBackground}>
        <CheckCircleIcon
          className={clsx(classes.icon, isActive && classes.activeIcon)}
        />
      </Box>
      <Box>{children}</Box>
    </Box>
  );
};
